import { AnyAction } from "@reduxjs/toolkit";
import { Observable, OperatorFunction, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { Action } from "typescript-fsa";

export function catchAsyncError<A>(handler: (error: any) => AnyAction): OperatorFunction<AnyAction, Action<A>>;

export function catchAsyncError(handler: (error: any) => AnyAction) {
  return (actions$: Observable<AnyAction>) => actions$.pipe(catchError((error) => of(handler(error))));
}
